import React from 'react';
import './ServicePageSplit.css';

const ServicePageSplit = ({
  variant = 'cream',
  tag,
  heading,
  headingAccent,
  paragraphs,
  image,
  imageAlt,
  tags,
}) => (
  <section className={`service-page-split service-page-split--${variant}`}>
    <div className="service-page-split__inner site-rail site-rail--wide">
      <div className="service-page-split__content">
        <span className="service-page-split__tag">{tag}</span>
        <h2 className="service-page-split__heading">
          {heading}
          {headingAccent && (
            <span className="service-page-split__heading-accent">{headingAccent}</span>
          )}
        </h2>
        <div className="service-page-split__body">
          {paragraphs.map((text, i) => (
            <p key={i}>{text}</p>
          ))}
        </div>
      </div>

      <div className="service-page-split__media">
        <div className="service-page-split__image-wrap">
          <img src={image} alt={imageAlt} className="service-page-split__image" />
        </div>
        <div className="service-page-split__tags">
          {tags.map(tagLabel => (
            <span key={tagLabel} className="service-page-split__chip">
              {tagLabel}
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ServicePageSplit;
